import {jQuery as $, lodash as _} from 'lib/shim';



const SELECTOR = '.molecule-google-map';

class MoleculeGoogleMap {

	constructor(app, $element){
		if( !$.isSet($element.dataDuo('primed')) ){
			$element.dataDuo('primed', true);

			this._app = app;
			this._id = $.randomUuid(true);
			this._$element = $element;
			this._$mapWrapper = this._$element.find('.map-wrapper').first();
			this._$map = this._$mapWrapper.find('.map').first();
			this._googleMap = null;
			this._markers = [];
			this._markerCluster = null;
			this._dataUrl = this._$element.dataDuo('url');
			this._defaultLocation = this._$element.dataDuo('location');
			this._defaultInfowindow = this._$element.dataDuo('default-infowindow');

			$.when(this._app.loadDynamicDependency('GoogleMapsApi', this._dataUrl, 'google.maps')).done(() => {
				this._googleMapsApi = window.google.maps;
				this._geoCoder = new this._googleMapsApi.Geocoder();
				this._infoWindow = new this._googleMapsApi.InfoWindow();
				this._latLngBounds = new this._googleMapsApi.LatLngBounds();
				this._prime();
			}).fail(() => {
				throw new Error('GoogleMapsApi could not be loaded');
			});
		}

		return $element;
	}



	_prime() {
		let defaultCenter = new this._googleMapsApi.LatLng(0, 0);

		//init the map with initial location
		this._buildMap(defaultCenter);

		this.ucMapProviderDisabled = window.uc.disabledProviders.SCRIPT ? window.uc.disabledProviders.SCRIPT.find(function (item) {
			return item.pid.includes('S1pcEj_jZX');
		}) : false;

		// handle consent layer with uc-block script
		if (!this.ucMapProviderDisabled) {

			$.when(this._resolveMarkerByAdress(this._defaultLocation)).done((result) => {
				defaultCenter = result;
			}).always(() => {
				this._createMarker(defaultCenter);
			});

			this._$element.on('add-marker', (e, data) => {
				this._createMarker(new this._googleMapsApi.LatLng(data.location.lat, data.location.lng), data.html);
			});

			this._$element.on('clear-markers', (e) => {
				this._clearMarkers();
			});

			this._$element.on('fit-bounds', (e) => {
				this._googleMapsApi.event.addListenerOnce(this._googleMap, 'bounds_changed', (event) => {
					if (this._googleMap.getZoom() > 10) {
						this._googleMap.setZoom(10);
					}
				});
				this._googleMap.fitBounds(this._latLngBounds);
			});
		} else {
			uc.reloadOnOptIn("S1pcEj_jZX"); // reload page on maps opt-in
		}
	}



	_buildMap(center) {
		this._googleMap = new this._googleMapsApi.Map(this._$map.get(0), {
			mapTypeId: this._googleMapsApi.MapTypeId.ROADMAP,
			mapTypeControl : false,
			mapTypeControlOptions: {style: this._googleMapsApi.MapTypeControlStyle.HORIZONTAL_BAR},
			streetViewControl : false,
			gestureHandling: 'cooperative',
			center: center,
			// zoomControl: false,
			zoom: 4
		});
	}



	_resolveMarkerByAdress(address) {
		let deferred = $.Deferred();

		this._geoCoder.geocode({'address': address}, function (results, status) {
			if (status === 'OK' ) {
				let resultlocation = results[0].geometry.location;
				deferred.resolve({lat: resultlocation.lat(), lng: resultlocation.lng()});
			} else {
				deferred.reject(new Error('Geocode was not successful for the following reason: ' + status));
			}
		});

		return deferred;
	}



	_createMarker(markerData, content) {
		let marker = new this._googleMapsApi.Marker({
			map: this._googleMap,
			position: markerData,
			animation: this._googleMapsApi.Animation.DROP
		});

		this._latLngBounds.extend(marker.getPosition());

		if( $.isSet(content) && !$.isEmpty(content) ) {
			marker.addListener('click', () => {
				this._infoWindow.setContent(content);
				this._infoWindow.open(this._googleMap, marker);
			});
		}

		this._markers.push(marker);
	}


	// adds markers to the map with setMap GoogleMapsApi method
	_setMapOnAll(map) {
		for (let i = 0; i < this._markers.length; i++){
			this._markers[i].setMap(map);
		}
	}



	_clearMarkers() {
		this._setMapOnAll(null);
		this._latLngBounds = new this._googleMapsApi.LatLngBounds();
		this._markers = [];
	}


	// not necessary yet
	_showMarkers() {
		this._setMapOnAll(this._googleMap);
	}
}



export function init(app){
	let $elements = $();

	$(SELECTOR).each(function(){
		let $this = $(this);

		$elements = $elements.add(new MoleculeGoogleMap(app, $this));
	});

	return $elements;
}
